import { apiSlice } from "../apiSlice";

const branchApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getBranchList: builder.query({
            query: () => {
                return {
                    url: `/api/branch/list`,
                    method: "GET",
                };
            },
            providesTags: ['branchList']
        }),
        createBranch: builder.mutation({
            query: (body) => {
                return {
                    url: `/api/branch/create`,
                    method: "POST",
                    body
                };
            },
            invalidatesTags: ['branchList']
        }),
        updateBranch: builder.mutation({
            query: (body) => {
                return {
                    url: `/api/branch/profile/update/${body.branchId}`,
                    method: "PATCH",
                    body: body.data
                };
            },
            invalidatesTags: ['branchList']
        }),
    }),
    overrideExisting: true,
});

export const { useGetBranchListQuery, useCreateBranchMutation, useUpdateBranchMutation } = branchApiSlice;
